module.exports = __webpack_public_path__ + "lazer2.png?2d1f19ec26993340bfc73aa4bd95d802";